<script setup>
import Draggable from 'vuedraggable';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import KanbanCard from 'dashboard/components-next/Contacts/Kanban/KanbanCard.vue';

defineProps({
  columnLabel: { type: String, required: true },
  contacts: { type: Array, default: () => [] },
  meta: {
    type: Object,
    default: () => ({ count: 0, hasMore: false }),
  },
  isFetching: { type: Boolean, default: false },
  isFetchingMore: { type: Boolean, default: false },
});

const emit = defineEmits(['change', 'loadMore', 'cardClick']);

const { t } = useI18n();
</script>

<template>
  <div
    class="flex flex-col flex-shrink-0 w-72 h-full min-h-0 bg-n-alpha-1 rounded-xl border border-n-weak"
  >
    <div class="flex items-center justify-between gap-2 px-3 py-3">
      <span class="text-sm font-medium truncate text-n-slate-12">
        {{ columnLabel }}
      </span>
      <span
        class="px-1.5 py-0.5 text-xs rounded-md text-n-slate-11 bg-n-alpha-2"
      >
        {{ meta.count }}
      </span>
    </div>

    <div v-if="isFetching" class="flex items-center justify-center py-6">
      <Spinner />
    </div>

    <Draggable
      v-else
      :list="contacts"
      group="kanban-cards"
      item-key="id"
      animation="200"
      ghost-class="opacity-50"
      class="flex flex-col flex-1 gap-2 px-3 pb-3 overflow-y-auto"
      @change="emit('change', $event)"
    >
      <template #item="{ element }">
        <KanbanCard
          :id="element.id"
          :name="element.name"
          :email="element.email"
          :phone-number="element.phoneNumber"
          :thumbnail="element.thumbnail"
          :additional-attributes="element.additionalAttributes"
          @click="emit('cardClick', $event)"
        />
      </template>
    </Draggable>

    <div v-if="meta.hasMore" class="px-3 pb-3">
      <Button
        :label="t('CONTACTS_LAYOUT.KANBAN.COLUMN.LOAD_MORE')"
        variant="ghost"
        color="slate"
        size="sm"
        class="w-full"
        :is-loading="isFetchingMore"
        @click="emit('loadMore')"
      />
    </div>
  </div>
</template>
